// extracted by mini-css-extract-plugin
export default {"filmCard":"Film_filmCard__6tkOi","image":"Film_image__VlSsM","genre":"Film_genre__QlufX","title":"Film_title__tN9Sw"};